"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreateTariff = _interopRequireDefault(require("../model/CreateTariff"));
var _UpdateTariff = _interopRequireDefault(require("../model/UpdateTariff"));
var _UpdateTariffCharge = _interopRequireDefault(require("../model/UpdateTariffCharge"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Tariffs service.
* @module api/TariffsApi
* @version 0.1.0
*/
var TariffsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new TariffsApi. 
  * @alias module:api/TariffsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TariffsApi(apiClient) {
    _classCallCheck(this, TariffsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {Number} id 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(TariffsApi, [{
    key: "callDeleteWithHttpInfo",
    value: function callDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling callDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "callDelete",
    value: function callDelete(id) {
      return this.callDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateTariff} opts.createTariff Payload for creating a new tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "createWithHttpInfo",
    value: function createWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['createTariff'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateTariff} opts.createTariff Payload for creating a new tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "create",
    value: function create(opts) {
      return this.createWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.attachCharges Attach charges to the tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWithHttpInfo",
    value: function getWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling get");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'attachCharges': opts['attachCharges']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.attachCharges Attach charges to the tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "get",
    value: function get(id, opts) {
      return this.getWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} virtualMeterId ID of the virtual meter to view the bill for.
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date of the bill to view. If empty, today's date will be used.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getBillWithHttpInfo",
    value: function getBillWithHttpInfo(virtualMeterId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'virtualMeterId' is set
      if (virtualMeterId === undefined || virtualMeterId === null) {
        throw new Error("Missing the required parameter 'virtualMeterId' when calling getBill");
      }
      var pathParams = {
        'virtualMeterId': virtualMeterId
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/bill/{virtualMeterId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} virtualMeterId ID of the virtual meter to view the bill for.
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date of the bill to view. If empty, today's date will be used.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getBill",
    value: function getBill(virtualMeterId, opts) {
      return this.getBillWithHttpInfo(virtualMeterId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} chargeId ID of the charge to view the detail for.
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date of the bill to view. If empty, today's date will be used.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getBillChargeDetailWithHttpInfo",
    value: function getBillChargeDetailWithHttpInfo(chargeId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'chargeId' is set
      if (chargeId === undefined || chargeId === null) {
        throw new Error("Missing the required parameter 'chargeId' when calling getBillChargeDetail");
      }
      var pathParams = {
        'chargeId': chargeId
      };
      var queryParams = {
        'date': opts['date']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/bill/charges/{chargeId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} chargeId ID of the charge to view the detail for.
     * @param {Object} opts Optional parameters
     * @param {String} opts.date Date of the bill to view. If empty, today's date will be used.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getBillChargeDetail",
    value: function getBillChargeDetail(chargeId, opts) {
      return this.getBillChargeDetailWithHttpInfo(chargeId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.siteId ID if filtering by site. Either siteId or virtualMeterId is required.
     * @param {Number} opts.virtualMeterId ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
     * @param {Boolean} opts.active Return only active tariffs for the current date.
     * @param {String} opts.energyProvider Filter for the tariff's energy provider.
     * @param {String} opts.dateMin Minimum date the tariff must be active; in YYYY-MM-DD format.
     * @param {String} opts.dateMax Maximum date the tariff can be active; in YYYY-MM-DD format.
     * @param {Array.<Number>} opts.statuses List of statuses to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "listWithHttpInfo",
    value: function listWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'siteId': opts['siteId'],
        'virtualMeterId': opts['virtualMeterId'],
        'active': opts['active'],
        'energyProvider': opts['energyProvider'],
        'dateMin': opts['dateMin'],
        'dateMax': opts['dateMax'],
        'statuses': this.apiClient.buildCollectionParam(opts['statuses'], 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Number} opts.siteId ID if filtering by site. Either siteId or virtualMeterId is required.
     * @param {Number} opts.virtualMeterId ID if filtering by virtual meter. Either siteId or virtualMeterId is required.
     * @param {Boolean} opts.active Return only active tariffs for the current date.
     * @param {String} opts.energyProvider Filter for the tariff's energy provider.
     * @param {String} opts.dateMin Minimum date the tariff must be active; in YYYY-MM-DD format.
     * @param {String} opts.dateMax Maximum date the tariff can be active; in YYYY-MM-DD format.
     * @param {Array.<Number>} opts.statuses List of statuses to filter by.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "list",
    value: function list(opts) {
      return this.listWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateTariff} opts.updateTariff Payload for updating an existing tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWithHttpInfo",
    value: function updateWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateTariff'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling update");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateTariff} opts.updateTariff Payload for updating an existing tariff.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "update",
    value: function update(id, opts) {
      return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateTariffCharge} opts.updateTariffCharge Payload for updating an existing tariff charge.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateChargeWithHttpInfo",
    value: function updateChargeWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateTariffCharge'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateCharge");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/tariffs/charges/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateTariffCharge} opts.updateTariffCharge Payload for updating an existing tariff charge.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "updateCharge",
    value: function updateCharge(id, opts) {
      return this.updateChargeWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return TariffsApi;
}();
exports["default"] = TariffsApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/TariffsApi.js
// module id = sgfu
// module chunks = 3